export default "__VITE_ASSET__FhcpiYqJ__"